import React from 'react';
import Hero from '../components/Hero';
import {Link} from 'react-router-dom';

const Product = () => {
    return (
        <div>
            product
        </div>
    );
};

export default Product;